import { fetchWithAuthCheck } from '@/services/fetchWithAuthCheck'
import type { DashboardInfoResponse, GetInfoResponse } from '@/types/dashboard'

export async function getDashboardInfo(
  workItemId: number,
): Promise<DashboardInfoResponse> {
  return fetchWithAuthCheck<GetInfoResponse>(
    `/dashboard/getInfo?workOrderId=${workItemId}`,
  )
}
